var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6253 5V13.125C15.6253 13.2908 15.5595 13.4497 15.4423 13.5669C15.3251 13.6842 15.1661 13.75 15.0003 13.75C14.8346 13.75 14.6756 13.6842 14.5584 13.5669C14.4412 13.4497 14.3753 13.2908 14.3753 13.125V6.50859L5.44254 15.4422C5.32526 15.5595 5.1662 15.6253 5.00035 15.6253C4.8345 15.6253 4.67544 15.5595 4.55816 15.4422C4.44088 15.3249 4.375 15.1659 4.375 15C4.375 14.8341 4.44088 14.6751 4.55816 14.5578L13.4918 5.625H6.87535C6.70959 5.625 6.55062 5.55915 6.43341 5.44194C6.3162 5.32473 6.25035 5.16576 6.25035 5C6.25035 4.83424 6.3162 4.67527 6.43341 4.55806C6.55062 4.44085 6.70959 4.375 6.87535 4.375H15.0003C15.1661 4.375 15.3251 4.44085 15.4423 4.55806C15.5595 4.67527 15.6253 4.83424 15.6253 5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/ArrowUpRight.28c5b589ac7e274c02368b18c5117e6d.svg";
export { ForwardRef as ReactComponent };